var React = require('react');

function MonitorHeartRate (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 64v384H64V288h118.11l27.58 55.16a16 16 0 0 0 28.62 0L288 243.78 310.11 288H400a16 16 0 0 0 0-32h-70.11l-27.58-55.16a16 16 0 0 0-28.62 0L224 300.22l-19.9-39.8A8 8 0 0 0 197 256H64V64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M528 0H48A48 48 0 0 0 0 48v416a48 48 0 0 0 48 48h480a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 448H64V64h448z","className":"fa-primary","key":2})]);
}

MonitorHeartRate.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = MonitorHeartRate;

MonitorHeartRate.default = MonitorHeartRate;
